


























import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { TableColumn } from "../../models/UI/TableColumn";
import { ContactApi } from "../../api/ContactApi";
import { Option } from "../../models/Option";

export default {
    name: "AvisDeVirementListFilters",
    components: { TableSort, TableFilters },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            filters: {},
            ContactApi: new ContactApi(),
            columns: [
                {
                    id: "clientIds",
                    name: "Client",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "clients.nom",
                },
                {
                    id: "clientName",
                    name: "Client (nom extrait)",
                    type: TableColumn.ColumnType.text,
                    sort_field: "client_name",
                },
                {
                    id: "date",
                    name: "Date",
                    type: TableColumn.ColumnType.date_range,
                    sort_field: "date",
                    // Pas de période par défaut : la liste affiche tous les
                    // avis et l'export PDF suit les filtres réellement posés.
                },
                {
                    id: "montant",
                    name: "Montant",
                    sort_field: "montant",
                },
                {
                    id: "statutRapprochement",
                    name: "Rapprochement",
                    type: TableColumn.ColumnType.option,
                    options: [
                        { id: 0, name: "Non effectué" },
                        { id: 1, name: "Partiel" },
                        { id: 2, name: "Effectué" },
                    ],
                    sort_field: "statut_rapprochement",
                },
                {
                    id: "created_at",
                    name: "Date d'ajout",
                    sort_field: "created_at",
                    default_sort: true,
                    default_value: TableColumn.SortOrder.desc,
                },
            ],
        };
    },
    created() {
        let self = this;
        // Pas de filtre sur le type de client : les émetteurs d'avis peuvent
        // être enregistrés comme Syndic, Bureau, etc.
        self.ContactApi.getAllAsOptions({
            useCache: true,
        }).then(function (response) {
            let col = _.find(self.columns, { id: "clientIds" });
            col.options = Option.toTags(response);
        });
    },
    methods: {
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", this.getFilters());
            this.$emit("input", this.getFilters());
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
        importReleve(): void {
            // La modale d'import est portée par AvisDeVirementList.
            this.$emit("import-releve");
        },
        getFilters() {
            // Filtre client vide
            if (
                this.filters.clientIds &&
                _.includes(this.filters.clientIds, "-1")
            ) {
                this.filters.emptyClient = true;
            }
            return _.merge({}, this.filters);
        },
    },
};
